/*
  Pouch & Spark — AI analysis image gallery.
  The centering / condition images on the product page (a.pv-ctr__shot) open in a
  popup viewer instead of a new tab: prev/next (buttons, arrow keys, swipe),
  tap/click the picture to zoom in and pan, Esc / × / backdrop to close.
  The links keep their href, so without JS they still open the full image.
*/
(function () {
  if (window.__pvAnalysisGallery) return;
  window.__pvAnalysisGallery = true;

  // Serve through the store's own /cdn/shop/ path (edge-cached near PH) at a sensible width.
  function sized(src, w) {
    src = src.replace(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '/cdn/shop/');
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src;
    return src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var shots = [], box, stage, imgEl, capEl, countEl, prevBtn, nextBtn, idx = 0, lastFocus = null, zoomed = false;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'pv-agal';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Analysis images');
    box.hidden = true;
    box.innerHTML =
      '<div class="pv-agal__bar">' +
        '<span class="pv-agal__count" aria-live="polite"></span>' +
        '<span class="pv-agal__hint">Tap the image to zoom</span>' +
        '<button type="button" class="pv-agal__close" aria-label="Close">×</button>' +
      '</div>' +
      '<div class="pv-agal__stage"><img class="pv-agal__img" alt=""></div>' +
      '<button type="button" class="pv-agal__nav pv-agal__nav--prev" aria-label="Previous image">‹</button>' +
      '<button type="button" class="pv-agal__nav pv-agal__nav--next" aria-label="Next image">›</button>' +
      '<p class="pv-agal__cap"></p>';
    document.body.appendChild(box);
    stage = box.querySelector('.pv-agal__stage');
    imgEl = box.querySelector('.pv-agal__img');
    capEl = box.querySelector('.pv-agal__cap');
    countEl = box.querySelector('.pv-agal__count');
    prevBtn = box.querySelector('.pv-agal__nav--prev');
    nextBtn = box.querySelector('.pv-agal__nav--next');

    box.querySelector('.pv-agal__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    // a click anywhere except the picture or a button closes it
    box.addEventListener('click', function (e) { if (!e.target.closest('.pv-agal__img, button')) close(); });
    imgEl.addEventListener('click', function (e) { e.stopPropagation(); toggleZoom(e); });

    // swipe left/right (only when not zoomed — zoomed swipes pan the picture)
    var sx = 0, sy = 0;
    box.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (zoomed) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'Tab') { // keep focus inside the dialog
        var f = [].slice.call(box.querySelectorAll('button:not([hidden])'));
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { f[f.length - 1].focus(); e.preventDefault(); }
        else if (!e.shiftKey && i === f.length - 1) { f[0].focus(); e.preventDefault(); }
      }
    });
  }

  function setZoom(on, e) {
    zoomed = on;
    box.classList.toggle('is-zoomed', on);
    if (on && e) {
      // keep the tapped point under the finger/cursor
      var r = imgEl.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      requestAnimationFrame(function () {
        stage.scrollLeft = fx * stage.scrollWidth - stage.clientWidth / 2;
        stage.scrollTop = fy * stage.scrollHeight - stage.clientHeight / 2;
      });
    } else { stage.scrollLeft = 0; stage.scrollTop = 0; }
  }
  function toggleZoom(e) { setZoom(!zoomed, e); }

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = {}, animTimer = null, closeTimer = null;
  function fullSrc(a) { return sized(a.getAttribute('href'), 2000); }
  function preload(i) { // warm the neighbours so the next slide is already decoded
    var a = shots[(i + shots.length) % shots.length], u = fullSrc(a);
    if (cache[u]) return cache[u];
    var im = new Image(); im.decoding = 'async'; im.src = u; cache[u] = im; return im;
  }

  // Put slide i into the viewer. dir: +1 next, -1 previous, 0 first open (no slide).
  function render(i) {
    idx = (i + shots.length) % shots.length;
    var a = shots[idx], small = a.querySelector('img'), full = preload(idx);
    setZoom(false);
    imgEl.src = (full.complete && full.naturalWidth) ? full.src : ((small && small.currentSrc) || full.src);
    if (!(full.complete && full.naturalWidth)) full.addEventListener('load', function () { if (shots[idx] === a) imgEl.src = full.src; }, { once: true });
    imgEl.alt = small ? small.alt : '';
    var cap = a.querySelector('span');
    capEl.textContent = cap ? cap.textContent : '';
    countEl.textContent = (idx + 1) + ' / ' + shots.length;
    var many = shots.length > 1;
    prevBtn.hidden = !many; nextBtn.hidden = !many;
    if (many) { preload(idx + 1); preload(idx - 1); }
  }
  function show(i, dir) {
    if (!dir || reduced || box.hidden) { render(i); return; }
    // smooth change: current picture slides/fades out, the new one slides/fades in from the other side
    clearTimeout(animTimer);
    box.style.setProperty('--pv-agal-dir', dir);
    box.classList.remove('is-entering'); box.classList.add('is-leaving');
    animTimer = setTimeout(function () {
      render(i);
      box.classList.remove('is-leaving'); box.classList.add('is-entering');
      void imgEl.offsetWidth; // restart the transition
      box.classList.remove('is-entering');
    }, 170);
  }
  function go(d) { if (shots.length > 1) show(idx + d, d); }

  function open(i) {
    build();
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    box.classList.remove('is-leaving', 'is-entering');
    render(i);
    box.hidden = false;
    box.classList.add('is-hidden'); void box.offsetWidth; box.classList.remove('is-hidden'); // fade in
    document.documentElement.classList.add('pv-agal-open');
    box.querySelector('.pv-agal__close').focus();
  }
  function close() {
    if (!box || box.hidden) return;
    setZoom(false);
    document.documentElement.classList.remove('pv-agal-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    if (reduced) { box.hidden = true; return; }
    box.classList.add('is-hidden'); // fade out, then hide
    closeTimer = setTimeout(function () { box.hidden = true; box.classList.remove('is-hidden'); }, 200);
  }

  function init() {
    shots = [].slice.call(document.querySelectorAll('a.pv-ctr__shot'));
    shots.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" still work
        e.preventDefault();
        open(i);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
